<mat-drawer-container class="side-menu-wrapper mat-elevation-z0" autosize>
  <mat-drawer #drawer mode="side" disableClose="true" opened>
    <styles-menu-label class="app-version">v{{ appVersion() }}</styles-menu-label>

    <!--
      One wrapper, one flat list. Every row is a styles-menu-header with no children —
      the library gives them a `no-children` class for exactly this case. The wrapper is
      what draws the rounded notch on the selected/hovered row, so a second one would
      read as a separate block rather than a continuation of the same list.
    -->
    <styles-menu-wrapper>
      @for (item of items; track item.label) {
        @if (item.url) {
          <!--
            An external destination. No `route` is passed, so the library's own
            `navigate()` is a no-op and this handler owns the navigation — its header
            navigates with `Router.navigateByUrl`, which cannot leave the app.

            Opened from a click handler rather than by wrapping the row in an anchor:
            every row here is a bare styles-menu-header, so the list is one set of
            identical siblings. (A wrapper element would also be the only row with an
            extra level in the DOM.)
          -->
          <styles-menu-header
            [caption]="item.label"
            [icon]="item.icon"
            (click)="openExternal(item.url)"
          >
          </styles-menu-header>
        } @else {
          <!--
            routerLink/routerLinkActive rather than the header's own `route`: the library
            only re-evaluates `allowedRoutes` on a NavigationStart, so a row matching the
            URL the app was LOADED on never highlights. Angular's directive has no such
            gap. `open-link` is the class the library's own CSS watches for a
            router-driven selection and does not bind itself — using it is what gets the
            wrapper to draw its notch on the selected row, as it does on hover.
          -->
          <styles-menu-header
            [caption]="item.label"
            [icon]="item.icon"
            [routerLink]="item.route"
            [routerLinkActive]="activeRoutes(item).length ? 'open-link' : ''"
            [routerLinkActiveOptions]="{ exact: false }"
          >
          </styles-menu-header>
        }
      }
    </styles-menu-wrapper>
  </mat-drawer>

  <mat-drawer-content>
    <ng-content select="[page-content]"></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
